import { ReactElement } from 'react';
import { FormFieldText } from '@client/common/components/Form/FormFieldText';
import { getErrorMessage } from '@client/common/utils/form/form';
import { useTranslate } from '@client/i18n/hooks';
import { SearchResults } from '@client/myAccount/rma/components/SearchResults';
import { Props } from '@client/myAccount/rma/components/StandaloneSearchPage/Form/Form.types';
import { FIELD_NAME } from '@client/myAccount/rma/components/StandaloneSearchPage/Form/FormContainer.types';
import { useFormikContext } from 'formik';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from 'b2b-components/theme/components/Button';
import './Body.scss';

const Body = ({
  isSubmitting,
  rmaInvoiceData: {
    data: rmaInvoice,
    hasFailed: hasRmaInvoiceFailed,
    isLoaded: isRmaInvoiceLoaded,
  },
}: Props): ReactElement => {
  const { errors, handleSubmit, touched } = useFormikContext();
  const t = useTranslate();

  return (
    <>
      <form className='cds-Form--Inline RmaStandaloneSearchPageForm' onSubmit={handleSubmit}>
        <div className='cds-Form-Field'>
          <FormFieldText
            name={FIELD_NAME.debitorId}
            innerComponentProps={{
              error: getErrorMessage(
                errors[FIELD_NAME.debitorId],
                touched[FIELD_NAME.debitorId],
              ),
              text: { label: t('Customer number') },
            }}
          />
        </div>

        <div className="cds-Form-Field">
          <FormFieldText
            name={FIELD_NAME.invoiceId}
            innerComponentProps={{
              error: getErrorMessage(
                errors[FIELD_NAME.invoiceId],
                touched[FIELD_NAME.invoiceId],
              ),
              text: { label: t('Invoice number') },
            }}
          />
        </div>

        <div className="cds-Form-Buttons">
          <Button
            isDisabled={isSubmitting}
            size={BUTTON_SIZE.small}
            type={BUTTON_TYPE.submit}
          >
            {isSubmitting ? t('Searching...') : t('Search')}
          </Button>
        </div>
      </form>

      {(isRmaInvoiceLoaded || hasRmaInvoiceFailed) && (
        <SearchResults
          areResultsLimited={false}
          isStandalone={true}
          resultCount={rmaInvoice ? 1 : 0}
          results={rmaInvoice ? [rmaInvoice] : []}
        />
      )}
    </>
  );
};

export {
  Body,
};
